<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"  display: flex;\n  justify-content: center;\npadding-bottom:80px;\n"' class="rcontainer " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='" width: 480px; \/* \u0639\u0631\u0636 \u06a9\u0627\u0646\u062a\u06cc\u0646\u0631 \u0645\u062e\u0635\u0648\u0635 \u0645\u0648\u0628\u0627\u06cc\u0644 *\/\nheight:100%;\n"' class="inner-container bg-white shadow" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":1,"redirectToDashboard":true},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
